import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import SpecialtiesSection from './components/SpecialtiesSection';
import StructureSection from './components/StructureSection';
import DifferentialsSection from './components/DifferentialsSection';
import TestimonialsSection from './components/TestimonialsSection';
import DoctorsSection from './components/DoctorsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <SpecialtiesSection />
        <DifferentialsSection />
        <DoctorsSection />
        <StructureSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}